import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/job-definitions',
    name: 'job-definitions',
    meta: {
      title: 'Job Definitions'
    },
    component: () => import('@/views/job-definitions/JobDefinitionListView.vue')
  },
  {
    path: '/job-definitions/create',
    name: 'job-definition-create',
    meta: {
      title: 'Create Job Definition'
    },
    component: () => import('@/views/job-definitions/JobDefinitionCreateView.vue')
  },
  {
    path: '/job-definitions/:id',
    name: 'job-definition-edit',
    props: true,
    meta: {
      title: 'Edit Job Definition'
    },
    component: () => import('@/views/job-definitions/JobDefinitionEditView.vue'),
    children: [
      {
        path: '/job-definitions/:id/f/:section',
        name: 'job-definition-edit-section',
        props: true,
        meta: {
          title: 'Edit Job Definition'
        },
        component: () => import('@/views/job-definitions/JobDefinitionEditView.vue')
      }
    ]
  }
]

export default routes
